export default "__VITE_ASSET__ff36aadc__"